module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-529.3e9d121.woff2";